/**
 * Keep in sync with server: TotalWaterpoloArena.Application.Matches.Helpers.MatchCompetitionStageHelper.DefaultStages
 */
export const DEFAULT_MATCH_COMPETITION_STAGES: string[] = [
    'Standings',
    'Group A',
    'Group B',
    'Group C',
    'Group D',
    'Group E',
    'Group F',
    'Group G',
    'Group H',
    'Not relevant',
];

export function mergeMatchStageSelectOptions(
    extraStages: string[] | null | undefined,
    currentValue?: string | null
): { value: string; label: string }[] {
    const seen = new Set<string>();
    const opts: { value: string; label: string }[] = [];

    const push = (s: string): void => {
        const t = s.trim();
        if (!t || seen.has(t)) {
            return;
        }
        seen.add(t);
        opts.push({ value: t, label: t });
    };

    DEFAULT_MATCH_COMPETITION_STAGES.forEach(push);
    (extraStages || []).forEach(push);

    const cv = currentValue?.trim();
    if (cv && !seen.has(cv)) {
        push(cv);
        opts.unshift({ value: cv, label: `${cv} (saved on match — add to competition extras if everyone should use it)` });
    }

    return opts;
}
